module.exports = __webpack_public_path__ + "images/category_lp/pc/media1_2c4e5490f84af02bc0cec9134db9420c.jpg";